// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5689f484","488":"a9e0ecc8"}[chunkId] + ".chunk.js";
};